module.exports = __webpack_public_path__ + "img/collection-engagementRingsCordial.0c1be0b.webp";